import { render, staticRenderFns } from "./help.vue?vue&type=template&id=65a1de72&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&id=65a1de72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1de72",
  null
  
)

component.options.__file = "help.vue"
export default component.exports